/* Container — label wraps the hidden input and the visible checkmark.
   Stays `display: block` so multi-element labels (e.g. <>Remove all <strong>
   Element</strong> restrictions</>) preserve their inter-element whitespace.
   `min-height` guarantees enough vertical extent for the absolutely-positioned
   checkmark to center against. */
.container {
  display: block;
  position: relative;
  min-height: 20px;
  padding-left: 28px;
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Larger left padding when the checkmark is large, so the label clears the 20px box. */
.containerLarge {
  padding-left: 32px;
}

/* Hide the native input. */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Base checkmark — size-agnostic; the .small / .large modifier sets dimensions.
   Vertically centred against the label so the box aligns with the text and
   with any sibling flex items (e.g. colour swatches in the Update-All footer). */
.checkmark {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  border: 2px solid var(--color-easil-gray-x-light);
  border-radius: 4px;
  background-color: white;
}

.checkmark:hover,
.checkmark[data-is-hovered="true"] {
  border-color: var(--color-easil-gray);
}

.container input:checked ~ .checkmark {
  border: none;
  background-color: var(--color-easil-blue);
}

/* Tick / minus indicator — hidden by default, shown when checked. */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(./check.svg);
}

.container input:checked ~ .checkmark:after {
  display: block;
}

.container .checkmark[data-is-minus="true"]:after {
  background-image: url(./minus.svg);
}

/* --- Size: small (16×16) --- */
.small {
  height: 16px;
  width: 16px;
}

.small:after {
  width: 8px;
  height: 6px;
  background-size: 8px 6px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* --- Size: large (20×20) --- */
.large {
  height: 20px;
  width: 20px;
}

.large:after {
  width: 10px;
  height: 7.5px;
  background-size: 10px 7.5px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* --- Tone: dark (use on dark surfaces) --- */
.toneDark {
  border-color: #ffffff;
  background-color: rgba(255, 255, 255, 0.2);
}

.toneDark:hover,
.toneDark[data-is-hovered="true"] {
  border-color: #ffffff;
}

.container input:checked ~ .toneDark {
  border: none;
  background-color: var(--color-easil-blue);
}
